import React from 'react';
import { UploadCloud } from 'lucide-react';
import SolicitudDocViewer from '../SolicitudDocViewer';

export default function FormularioRespuesta({ 
  solicitud, 
  subirFiles, 
  setSubirFiles, 
  notificarCiudadano, 
  setNotificarCiudadano, 
  mensajeUpload, 
  setMensajeUpload, 
  handleSubirDocs, 
  subiendo 
}) {
  return (
    <div className="glass-card">
      <SolicitudDocViewer
        docs={solicitud.documentos || []}
        titulo="Documentos del Expediente"
        emptyText="Sin documentos adicionales."
      />

      <div style={{ background: 'var(--bg-body)', padding: '0.85rem', borderRadius: 8, border: '1px dashed var(--border-color)' }}>
        <p style={{ fontSize: '0.78rem', color: 'var(--text-muted)', margin: '0 0 0.5rem' }}>Adjuntar nuevos documentos al expediente (PDF, JPG, PNG - Máx 20MB):</p>
        <input type="file" multiple accept=".pdf,.jpg,.jpeg,.png" onChange={e => setSubirFiles(Array.from(e.target.files))}
          style={{ fontSize: '0.82rem', width: '100%', marginBottom: '0.6rem' }} />

        {/* Checkbox notificar */}
        <label style={{
          display: 'flex', alignItems: 'center', gap: 10,
          padding: '0.55rem 0.75rem',
          borderRadius: 8,
          border: `1.5px solid ${notificarCiudadano ? '#b87333' : 'var(--border-color)'}`,
          background: notificarCiudadano ? 'rgba(184,115,51,0.07)' : 'var(--bg-body)',
          cursor: 'pointer', userSelect: 'none',
          transition: 'all 0.18s ease',
          marginBottom: '0.2rem',
        }}>
          <input
            type="checkbox"
            checked={notificarCiudadano}
            onChange={e => setNotificarCiudadano(e.target.checked)}
            style={{ accentColor: '#b87333', width: 15, height: 15, cursor: 'pointer', flexShrink: 0 }}
          />
          <span style={{ fontSize: '0.82rem', lineHeight: 1.3 }}>
            ✉️ <strong style={{ color: notificarCiudadano ? '#b87333' : 'inherit' }}>
              Notificar al ciudadano
            </strong>
            <span style={{ display: 'block', fontSize: '0.72rem', color: 'var(--text-muted)', marginTop: 1 }}>
              Recibe un correo con el link a su solicitud.
              {!solicitud.email_verificado_at && (
                <span style={{ color: '#f59e0b', display: 'block' }}>⚠ Correo no validado</span>
              )}
            </span>
          </span>
        </label>

        {/* Mensaje opcional */}
        <textarea
          className="form-control"
          value={mensajeUpload}
          onChange={e => setMensajeUpload(e.target.value)}
          placeholder="Mensaje opcional para el ciudadano..."
          rows={2}
          style={{
            width: '100%',
            fontSize: '0.8rem',
            padding: '0.4rem',
            borderRadius: 6,
            border: '1px solid var(--border-color)',
            background: 'var(--bg-surface)',
            color: 'var(--text-main)',
            resize: 'vertical',
            marginBottom: '0.6rem',
            marginTop: '0.4rem',
            fontFamily: 'inherit',
          }}
        />

        {subirFiles.length > 0 && (
          <>
            <ul style={{ paddingLeft: '1.2rem', fontSize: '0.78rem', margin: '0 0 0.5rem', color: 'var(--text-muted)' }}>
              {subirFiles.map((f, i) => <li key={i}>{f.name}</li>)}
            </ul>
            <button className="btn btn-primary btn-sm"
              style={{ width: '100%', display: 'flex', justifyContent: 'center', gap: 6 }}
              onClick={handleSubirDocs} disabled={subiendo}>
              <UploadCloud size={15} />
              {subiendo ? 'Subiendo...' : `Subir ${subirFiles.length} archivo(s)${notificarCiudadano ? ' y notificar' : ''}`}
            </button>
          </>
        )}
      </div>
    </div>
  );
}
